export { default as FolderRulersSolidIcon } from './FolderRulersSolidIcon';
